import { Search, X } from "lucide-react";

// Reusable admin table filter bar: free-text search, select filters and an optional date range.
export function FilterBar({ q, setQ, placeholder = "Search…", selects = [], dates, setDates, onClear, testid = "filter" }) {
    const sel = "rounded-full border border-navy/15 bg-white px-3.5 py-2 text-sm outline-none focus:border-orange";
    return (
        <div className="mt-4 flex flex-wrap items-center gap-2" data-testid={`${testid}-bar`}>
            <div className="relative min-w-[200px] flex-1">
                <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-navy/35" />
                <input data-testid={`${testid}-search`} value={q} onChange={(e) => setQ(e.target.value)} placeholder={placeholder} className="w-full rounded-full border border-navy/15 bg-white py-2 pl-9 pr-4 text-sm outline-none focus:border-orange" />
            </div>
            {selects.map((s) => (
                <select key={s.key} data-testid={`${testid}-${s.key}`} value={s.value} onChange={(e) => s.set(e.target.value)} className={sel}>
                    <option value="">{s.label}</option>
                    {s.options.map((o) => <option key={o.value ?? o} value={o.value ?? o}>{o.label ?? o}</option>)}
                </select>
            ))}
            {dates && (
                <>
                    <input data-testid={`${testid}-from`} type="date" value={dates.from} onChange={(e) => setDates({ ...dates, from: e.target.value })} className={sel} title="From date" />
                    <input data-testid={`${testid}-to`} type="date" value={dates.to} onChange={(e) => setDates({ ...dates, to: e.target.value })} className={sel} title="To date" />
                </>
            )}
            {onClear && <button data-testid={`${testid}-clear`} onClick={onClear} className="flex items-center gap-1 rounded-full px-3 py-2 text-xs font-bold text-navy/55 hover:text-navy"><X size={13} /> Clear</button>}
        </div>
    );
}

export const inRange = (iso, d) => {
    const day = (iso || "").slice(0, 10);
    return (!d.from || day >= d.from) && (!d.to || day <= d.to);
};

export const uniq = (arr) => [...new Set(arr.filter(Boolean))].sort();
